import { EN_NO_OPTION, EN_YES_OPTION, ES_NO_OPTION, ES_YES_OPTION, FR_NO_OPTION, FR_YES_OPTION, NO_OPTION, PALOP_COUNTRIES, YES_OPTION } from "../constants"

export const formatYesNoDropdownLists = (originalValue, language = "pt") => {
    switch (language) {
        case 'pt':
            return originalValue ? YES_OPTION : NO_OPTION;
        break;
        case 'en':
            return originalValue ? EN_YES_OPTION : EN_NO_OPTION;
        break;
        case 'es':
            return originalValue ? ES_YES_OPTION : ES_NO_OPTION;
        break;
        case 'fr':
            return originalValue ? FR_YES_OPTION : FR_NO_OPTION;
        break;
        default:
            break;
    }
}

export const getYesNoDropdownList = (language) => {
    switch (language) {
        case 'pt':
            return [
                YES_OPTION,
                NO_OPTION
            ];
        break;
        case 'en':
            return [
                EN_YES_OPTION,
                EN_NO_OPTION
            ];
        break;
        case 'es':
            return [
                ES_YES_OPTION,
                ES_NO_OPTION
            ];
        break;
        case 'fr':
            return [
                FR_YES_OPTION,
                FR_NO_OPTION
            ];
        break;
        default:
            break;
    }
}

export const isAssociateFromAPalopCountry = (nationality) => {
    for (let i = 0; i < PALOP_COUNTRIES.length; i++) {
        if(PALOP_COUNTRIES[i] === nationality) return true;        
    }

    return false;
}

export const getDropdownMultiSelectionSimpleValues = (source) => {
    let valueCodes = [];

    for (let i = 0; i < source.length; i++) {
        valueCodes.push(source[i]);
    }

    return valueCodes.join(',');
}

export const getDropdownMultiSelectionValues = (source) => {
    let valueCodes = [];

    for (let i = 0; i < source.length; i++) {
        valueCodes.push(source[i].code);
    }

    return valueCodes.join(',');
}